import { Component } from '@angular/core'
import { ConfirmDeleteModalComponent } from '../confirm-delete-modal/confirm-delete-modal.component'
import { CreateEditModalComponent } from '../create-edit-modal/create-edit-modal.component'

@Component({
  selector: 'case-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [ConfirmDeleteModalComponent, CreateEditModalComponent]
})
export class FooterComponent {}
